import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { Trans } from "react-i18next";
import "../styles/components/Stopwatch.scss";

type Props = {
  onTimeUp: any;
  miliseconds: number;
};

const renderer = ({ hours, minutes, seconds, completed }: any) => {
  if (completed) {
    return (
      <span>
        <Trans i18nKey={"session_expired"} />
      </span>
    );
  } else {
    return (
      <span>
        {`${minutes} `}
        <Trans i18nKey={"minute"} /> {` ${seconds} `}
        <Trans i18nKey={"seconds"} />
      </span>
    );
  }
};

const Stopwatch = (props: Props) => {
  return (
    <div className="stopwatch">
      <div className="timer">
        <Countdown
          date={Date.now() + props.miliseconds}
          renderer={renderer}
          onComplete={props.onTimeUp}
          autoStart={true}
        />
      </div>
    </div>
  );
};
export default Stopwatch;
